module.exports = __webpack_public_path__ + "img/airtel_money.49c157ed.png";